import { render, staticRenderFns } from "./nearAccident.vue?vue&type=template&id=30c4fa0d"
import script from "./nearAccident.vue?vue&type=script&lang=js"
export * from "./nearAccident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30c4fa0d')) {
      api.createRecord('30c4fa0d', component.options)
    } else {
      api.reload('30c4fa0d', component.options)
    }
    module.hot.accept("./nearAccident.vue?vue&type=template&id=30c4fa0d", function () {
      api.rerender('30c4fa0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/near/nearAccident.vue"
export default component.exports